import React from 'react';
import { Gift, ArrowRight } from 'lucide-react';
export function BonusesSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    tag: 'BONO 1',
    title: 'Kit de Productos para Empezar en Detailing Automotriz',
    value: '$15.000',
    desc: 'La lista exacta de productos y herramientas que necesitas para empezar sin gastar una fortuna. Marcas recomendadas y dónde comprarlas.',
    image: 'https://cdn.magicpatterns.com/uploads/n4kdUTrKCiNAzTWQM3HpRp/ChatGPT_Image_4_mar_2026,_23_09_23.png'
  }, {
    tag: 'BONO 2',
    title: 'Cómo Conseguir Tus Primeros 10 Clientes de Detailing',
    value: '$25.000',
    desc: 'Estrategias probadas en redes sociales y boca a boca para llenar tu agenda rápido, incluso si nadie te conoce.',
    image: 'https://cdn.magicpatterns.com/uploads/4TcYiZEeSepa1PCTHFCNCL/ChatGPT_Image_4_mar_2026,_23_18_24.png'
  }, {
    tag: 'BONO 3',
    title: 'Guía Profesional de Precios y Servicios de Detailing',
    value: '$20.000',
    desc: 'Plantillas exactas de cuánto cobrar por cada servicio en Argentina. Deja de adivinar y cobra lo que tu trabajo realmente vale.',
    image: 'https://cdn.magicpatterns.com/uploads/1HbscGHy83PijR4aeQKdpK/ChatGPT_Image_4_mar_2026,_23_33_05.png'
  }];
  return <section className="bg-black py-20 px-4 relative overflow-hidden" data-id="element-72">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-73">
        <div className="absolute top-[20%] right-[10%] w-[40%] h-[40%] rounded-full bg-[#D4AF37] blur-[100px]" data-id="element-74"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#D4AF37]/20 mb-6" data-id="element-77">
            <Gift className="w-10 h-10 text-[#D4AF37]" data-id="element-78" />
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-79">
            BONOS EXCLUSIVOS
          </h2>
          <div className="inline-block bg-red-600 text-white text-xl md:text-3xl font-black px-6 py-2 rounded-lg uppercase transform -rotate-2 shadow-xl" data-id="element-80">
            ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-81">
          {bonuses.map((bonus, index) => <a key={index} href="#comprar" onClick={scrollToPricing} className="bg-gray-900 rounded-2xl border border-gray-800 overflow-hidden group hover:border-[#D4AF37] transition-all duration-300 hover:-translate-y-2 cursor-pointer flex flex-col" data-id="element-82">
              {/* Image Placeholder (1080x1080 aspect ratio) */}
              <div className="bg-gradient-to-br from-gray-800 to-black relative overflow-hidden border-b border-gray-800" data-id="element-83">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-84" />
                <div className="absolute top-4 left-4 bg-[#D4AF37] text-black text-xs font-black px-3 py-1 rounded uppercase tracking-wider z-10" data-id="element-85">
                  {bonus.tag}
                </div>
                <div className="absolute bottom-4 right-4 bg-black/50 backdrop-blur-sm rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity z-10" data-id="element-86">
                  <ArrowRight className="w-5 h-5 text-[#D4AF37]" data-id="element-87" />
                </div>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-88">
                <p className="text-gray-400 text-sm mb-4 flex-1" data-id="element-89">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-800" data-id="element-90">
                  <span className="text-gray-500 text-sm font-medium" data-id="element-91">
                    Valor normal:
                  </span>
                  <span className="text-red-500 font-bold line-through text-lg" data-id="element-92">
                    {bonus.value}
                  </span>
                </div>
                <div className="text-right mt-1" data-id="element-93">
                  <span className="text-green-500 font-black uppercase tracking-wider" data-id="element-94">
                    ¡HOY GRATIS!
                  </span>
                </div>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}